/* 2026.01.04 - Toe Beans – Shopify Subscriptions: CWV-optimized variant-change bridge
   Goal: ensure Shopify Subscriptions app block reacts immediately when variant changes.
   Strategy: listen once (capturing), then re-dispatch minimal events on the actual select[name="id"].
*/
(() => {
  const SELECTOR = 'select[name="id"][data-variants]';

  const lastValue = new WeakMap();
  const rafPending = new WeakMap();

  const fire = (el, type) => el.dispatchEvent(new Event(type, { bubbles: true }));

  const handle = (select) => {
    if (!select || select.tagName !== 'SELECT') return;
    if (!select.matches(SELECTOR)) return;

    const v = select.value;
    if (!v) return;

    const prev = lastValue.get(select);
    if (prev === v) return;
    lastValue.set(select, v);

    if (rafPending.get(select)) return;
    rafPending.set(select, true);

    requestAnimationFrame(() => {
      rafPending.set(select, false);

      // Minimal events apps commonly watch:
      fire(select, 'input');
      fire(select, 'change');

      // Lightweight custom hook (harmless if unused):
      const form = select.closest('form');
      if (form) {
        form.dispatchEvent(
          new CustomEvent('variant:changed', { bubbles: true, detail: { variantId: v } })
        );
      }
    });
  };

  const onChange = (e) => {
    const t = e.target;
    if (t && t.matches && t.matches(SELECTOR)) handle(t);
  };

  const onFocusIn = (e) => {
    const root = e.target && e.target.closest ? e.target.closest('.product_section, .product-main') : null;
    if (!root) return;
    const select = root.querySelector(SELECTOR);
    if (select) handle(select);
  };

  const init = () => {
    if (!document.querySelector(SELECTOR)) return;
    document.addEventListener('change', onChange, true);
    document.addEventListener('focusin', onFocusIn, true);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();